var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('notifications'),_c('side-bar',[_c('template',{slot:"links"},[_c('sidebar-item',{attrs:{"true":"","link":{
          name: _vm.$t('COMMON.DASHBOARD'),
          icon: 'ni ni-shop text-primary',
          path: '/dashboard',
        }}}),(
          _vm.$currentUserCan(_vm.$permissions.PERM_VIEW_MODULE_ESTABLISHMENT_INTERNAL_ORDERS) &&
          _vm.$currentUserManagesProductionCafeteria()
        )?_c('sidebar-item',{attrs:{"true":"","link":{
          name: _vm.$t('ESTABLISHMENT_INTERNAL_ORDERS.PRODUCTIONS_TO_MAKE'),
          icon: 'fa fa-utensils text-primary',
          path: '/productions',
        }}}):_vm._e(),_c('sidebar-item',{attrs:{"true":"","link":{
          name: _vm.$t('COMMON.ESTABLISHMENTS_DIRECTORY'),
          icon: 'ni ni-books text-primary',
          path: '/establishments-directory',
        }}}),(_vm.$currentUserCan(_vm.$permissions.PERM_VIEW_ANY_EVENTS))?_c('sidebar-item',{attrs:{"true":"","link":{
          name: _vm.$t('COMMON.EVENTS'),
          icon: 'fa fa-calendar-alt text-primary',
          path: '/events',
        }}}):_vm._e(),(_vm.$currentUserCan(_vm.$permissions.PERM_VIEW_APP_REPORTS))?_c('sidebar-item',{attrs:{"true":"","link":{
          name: _vm.$t('COMMON.REPORTS'),
          icon: 'fa fa-chart-area text-primary',
        }}},[(
            _vm.$currentUserCan(
              _vm.$permissions.PERM_VIEW_REPORTS_CASH_REGISTER_READINGS
            )
          )?_c('sidebar-item',{attrs:{"true":"","link":{
            name: _vm.$t('COMMON.CASH_REGISTER_READINGS'),
            path: '/reports/cashregister-readings',
          }}}):_vm._e(),(
            _vm.$currentUserCan(_vm.$permissions.PERM_VIEW_REPORTS_PRODUCTS)
          )?_c('sidebar-item',{attrs:{"true":"","link":{
            name: _vm.$t('COMMON.PRODUCTS_REPORT'),
            path: '/reports/products',
          }}}):_vm._e(),(
            _vm.$currentUserCan(_vm.$permissions.PERM_VIEW_REPORTS_POS_PRODUCTS)
          )?_c('sidebar-item',{attrs:{"true":"","link":{
            name: _vm.$t('COMMON.POS_PRODUCTS_REPORT'),
            path: '/reports/pos-products',
          }}}):_vm._e(),(
            _vm.$currentUserCan(_vm.$permissions.PERM_VIEW_REPORTS_WEEKLY_REPORTS) &&
            _vm.$currentUserDoesWeeklyReports()
          )?_c('sidebar-item',{attrs:{"true":"","link":{
            name: _vm.$t('COMMON.WEEKLY_REPORTS_REPORT'),
            path: '/reports/weekly-reports',
          }}}):_vm._e()],1):_vm._e(),_c('hr',{staticClass:"my-3",staticStyle:{"border-color":"rgba(0, 0, 0, 0.1) currentcolor currentcolor","border-style":"solid none none","border-width":"1px 0px 0px","border-image":"none 100% / 1 / 0 stretch","min-width":"80%","overflow":"visible","box-sizing":"content-box","height":"0px"}}),_c('lang-switcher')],1)],2),_c('div',{staticClass:"main-content"},[_c('dashboard-navbar',{attrs:{"type":_vm.$route.meta.navbarType}}),_c('div',{on:{"click":function($event){return _vm.$sidebar.displaySidebar(false)}}},[_c('fade-transition',{attrs:{"duration":200,"origin":"center top","mode":"out-in"}},[_c('router-view')],1)],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }